import React from 'react';

import { getSelectedRollingPeriod, isFactorTrendMetric, isRollingMetric } from 'venn-utils';

import { useRecoilValue } from 'recoil';
import { customizedBlock } from 'venn-state';
import { Block } from '../../core';

export const RollingPeriod = ({ id }: { id: string }) => {
  const block = useRecoilValue(customizedBlock(id));
  const { rollingYears, selectedMetrics } = block;
  const factorTrendMetricSelected = isFactorTrendMetric(selectedMetrics);
  const rollingTimeseriesSelected = isRollingMetric(selectedMetrics);

  if (!rollingTimeseriesSelected && !factorTrendMetricSelected) {
    return null;
  }

  const selectedOption = getSelectedRollingPeriod(rollingYears, factorTrendMetricSelected);

  return <Block.MetadataItem iconType="wave-sine">Rolling Period: {selectedOption.label}</Block.MetadataItem>;
};
